import React from 'react'
import banner from '../../../assets/pictures/bannerRecovery.png'
import './styles.css'
import recoveryLetters from '../../../assets/images/Casas-de-recuperación.png'

const BannerSpecialist = () => {
  return (
    <div className='contain-banner-specialist'>
        <img src={banner} alt="" />
        <div className='effect-black-specialist'>
            <section className='text-Banner-specialist'>
               <img src={recoveryLetters} alt="espcialist" />
               <p>Selecciona el hospedaje en cualquier lugar del mundo, descansa como en casa.</p>
            </section>
        </div>
    </div>
  )
}

export default BannerSpecialist